@if (delegate.data && columns) {
  <div #axis DualAxis [height]="this.height" class="dual-axis" (axisScroll)="scroll($event)"
       [attr.aria-busy]="pagingMode === 'pages' && loading.getValue() ? true : null">
    @if ((isMobile || delegate.forceCards) && delegate.cardTemplateOutlet) {
      <div class="card-list">
        @for (o of delegate.data | sorted:(delegate.sorter ? delegate.sorter : null); track rowTrack(o)) {
          <div class="card-row" [ngClass]="delegate.rowClass ? delegate.rowClass(o.data) : null"
               (click)="cardRowClick($event, o)">
            @if (hasRowMenu) {
              @if (rowMenu(o); as items) {
                @if (items.length) {
                  <button nbButton ghost status="basic" size="tiny" class="row-kebab card-kebab"
                          [nbPopover]="cardRowMenuTpl" nbPopoverTrigger="click" nbPopoverPlacement="bottom"
                          #rowKebabPop="nbPopover"
                          aria-label="Actions">
                    <nb-icon icon="more-vertical-outline"></nb-icon>
                  </button>
                  <ng-template #cardRowMenuTpl>
                    <div class="kebab-popup">
                      @for (it of items; track it.data.action) {
                        <button class="kebab-item" [class.kebab-item--danger]="it.data.action === 'delete'"
                                (click)="rowMenuAction(it.data.action, it.data.node)">
                          <nb-icon [icon]="it.icon"></nb-icon>
                          {{ it.title }}
                        </button>
                      }
                    </div>
                  </ng-template>
                }
              }
            }
            <ng-container [ngTemplateOutlet]="delegate.cardTemplateOutlet"
                          [ngTemplateOutletContext]="{row: o.data, node: o, columns: columns}"></ng-container>
          </div>
        }
        @if (loading.getValue() && (!delegate.data || !delegate.data.length)) {
          <span class="sk-sr" role="status" aria-live="polite">{{ 'loading' | translate }}</span>
          @for (r of skeletonRows; track r) {
            <div class="sk-card" aria-hidden="true">
              <div class="sk-card-head">
                <span class="sk-avatar"></span>
                <span class="sk-bar"></span>
              </div>
              <span class="sk-bar"></span>
              <span class="sk-bar"></span>
            </div>
          }
        }
        @if (!loading.getValue() && !appending.getValue() && (loadFailed | async)) {
          <div class="card-state" role="alert">
            {{ 'loadfailed' | translate }}
            <button type="button" nbButton size="tiny" ghost status="primary" (click)="retry()">{{ 'retry' | translate }}</button>
          </div>
        } @else if (!loading.getValue() && !appending.getValue() && (!delegate.data || !delegate.data.length)) {
          <div class="card-state">{{ 'noresults' | translate }}</div>
        }
      </div>
    } @else if (experimentalGrid) {
      <!-- Staging spike (#1465 follow-up, Market Overview only): CSS Grid + subgrid
           replaces the table's per-cell translateX pin with two full-height sticky
           wrapper columns. See DualAxisComponent.experimentalGrid for scope limits. -->
      @let rows = delegate.data | sorted:(delegate.sorter ? delegate.sorter : null);
      <div class="axis-grid" GridRowHover [style.grid-template-columns]="gridTemplateColumns">
        @for (c of columns; track c) {
          <div class="cell header-cell" (click)="sort(c, $event)" [title]="c.title | translate" [attr.aria-sort]="sortAria(c)">
            <div class="cell-content">
              @if (c.subtitle) {
                <span [nbTooltip]="c.subtitle | translate">{{ c.title | translate }}</span>
              }
              @if (!c.subtitle) {
                <span>{{ c.title | translate }}</span>
              }
              <div>
                @if (sortable(c)) {
                  <button type="button" nbButton status="primary" class="sort-indicator"
                          [class.sort-indicator--active]="sortPrimary(c)"
                          [attr.aria-label]="('sortby' | translate) + ' ' + (c.title | translate)">
                    @if (sorted(c); as sort) {
                      <nb-icon [icon]="sort === 1 ? 'arrow-up-outline' : 'arrow-down-outline'"></nb-icon>
                    } @else {
                      <span class="sort-indicator__idle" aria-hidden="true">
                        <nb-icon icon="arrow-up-outline"></nb-icon>
                        <nb-icon icon="arrow-down-outline"></nb-icon>
                      </span>
                    }
                  </button>
                }
                @if (c.filter !== false) {
                  <button nbButton status="primary" [class.active]="filtervalid(c)" (click)="filter(c, $event)"><nb-icon icon="funnel-outline"></nb-icon></button>
                }
              </div>
            </div>
          </div>
        }

        @for (o of rows; track rowTrack(o); let r = $index) {
          @for (c of columns; track c) {
            <div class="cell" [attr.data-row]="r" [ngStyle]="c.style" (click)="delegate.selectRow ? delegate.selectRow($event, o) : null">
              <div class="cell-content">
                <ng-container [ngTemplateOutlet]="delegate.cellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, column: c, node: o, isHeader: false}">
                </ng-container>
              </div>
            </div>
          }
        }

        <div class="pin pin-left" [style.grid-row]="gridPinRowSpan" [style.grid-template-columns]="gridLeftPinColumns">
          @for (s of delegate.stickyColumnsLeft; track s.name) {
            <div class="cell header-cell" (click)="sort(s, $event)" [attr.aria-sort]="sortAria(s)">
              <div class="cell-content">
                @if (s.subtitle) {
                  <span [nbTooltip]="s.subtitle | translate">{{ s.title | translate }}</span>
                }
                @if (!s.subtitle) {
                  <span>{{ s.title | translate }}</span>
                }
                <div>
                  @if (sortable(s)) {
                    <button type="button" nbButton status="primary" class="sort-indicator"
                            [class.sort-indicator--active]="sortPrimary(s)"
                            [attr.aria-label]="('sortby' | translate) + ' ' + (s.title | translate)">
                      @if (sorted(s); as sort) {
                        <nb-icon [icon]="sort === 1 ? 'arrow-up-outline' : 'arrow-down-outline'"></nb-icon>
                      } @else {
                        <span class="sort-indicator__idle" aria-hidden="true">
                          <nb-icon icon="arrow-up-outline"></nb-icon>
                          <nb-icon icon="arrow-down-outline"></nb-icon>
                        </span>
                      }
                    </button>
                  }
                  @if (s.filter !== false) {
                    <button nbButton status="primary" [class.active]="filtervalid(s)" (click)="filter(s, $event)"><nb-icon icon="funnel-outline"></nb-icon></button>
                  }
                </div>
              </div>
            </div>
          }
          @for (o of rows; track rowTrack(o); let r = $index) {
            @for (s of delegate.stickyColumnsLeft; track s.name) {
              <div class="cell" [attr.data-row]="r" [ngStyle]="s.style">
                <div class="cell-content">
                  <ng-container [ngTemplateOutlet]="delegate.cellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, column: s, node: o, isHeader: false}">
                  </ng-container>
                </div>
              </div>
            }
          }
        </div>

        <!-- No right pins (Intake list): no wrapper, or its fixed grid-column -3/-1 lands on the last real columns. -->
        @if (delegate.stickyColumnsRight?.length) {
        <div class="pin pin-right" [style.grid-row]="gridPinRowSpan" [style.grid-template-columns]="gridRightPinColumns">
          @for (s of delegate.stickyColumnsRight; track s.name) {
            <div class="cell header-cell" (click)="sort(s, $event)" [attr.aria-sort]="sortAria(s)" [style.width.px]="s.stickyWidth" [style.min-width.px]="s.stickyWidth" [style.max-width.px]="s.stickyWidth">
              <div class="cell-content">
                <span>{{ s.title | translate }}</span>
                <div>
                  @if (sortable(s)) {
                    <button type="button" nbButton status="primary" class="sort-indicator"
                            [class.sort-indicator--active]="sortPrimary(s)"
                            [attr.aria-label]="('sortby' | translate) + ' ' + (s.title | translate)">
                      @if (sorted(s); as sort) {
                        <nb-icon [icon]="sort === 1 ? 'arrow-up-outline' : 'arrow-down-outline'"></nb-icon>
                      } @else {
                        <span class="sort-indicator__idle" aria-hidden="true">
                          <nb-icon icon="arrow-up-outline"></nb-icon>
                          <nb-icon icon="arrow-down-outline"></nb-icon>
                        </span>
                      }
                    </button>
                  }
                  @if (s.filter !== false) {
                    <button nbButton status="primary" [class.active]="filtervalid(s)" (click)="filter(s, $event)"><nb-icon icon="funnel-outline"></nb-icon></button>
                  }
                </div>
              </div>
            </div>
          }
          @for (o of rows; track rowTrack(o); let r = $index) {
            @for (s of delegate.stickyColumnsRight; track s.name; let lastCol = $last) {
              <div class="cell" [attr.data-row]="r" [class.last-col]="lastCol" [ngStyle]="s.style" [style.width.px]="s.stickyWidth" [style.min-width.px]="s.stickyWidth" [style.max-width.px]="s.stickyWidth">
                <div class="cell-content">
                  <ng-container [ngTemplateOutlet]="delegate.cellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, column: s, node: o, isHeader: false}">
                  </ng-container>
                </div>
              </div>
            }
          }
        </div>
        }
      </div>

      @if (loading.getValue() && (!delegate.data || !delegate.data.length)) {
        <div class="card-state" role="status" aria-live="polite">{{ 'loading' | translate }}</div>
      } @else if (!loading.getValue() && !appending.getValue() && (loadFailed | async)) {
        <div class="card-state" role="alert">
          {{ 'loadfailed' | translate }}
          <button type="button" nbButton size="tiny" ghost status="primary" (click)="retry()">{{ 'retry' | translate }}</button>
        </div>
      } @else if (!loading.getValue() && !appending.getValue() && (!delegate.data || !delegate.data.length)) {
        <div class="card-state">{{ 'noresults' | translate }}</div>
      }
    } @else {
    <table class="standard" cdkDropList [class.dragging]="dragging" (cdkDropListDropped)="dropped($event)">
      <thead>
        <tr>
          @for (s of delegate.stickyColumnsLeft; track s.name) {
            <th (click)="sort(s, $event)" class="sticky-column left" [attr.aria-sort]="sortAria(s)">
              @if (s.subtitle) {
                <span [nbTooltip]="s.subtitle | translate">{{ s.title | translate }}</span>
              }
              @if (!s.subtitle) {
                <span>{{ s.title | translate }}</span>
              }
              <div>
                @if (sortable(s)) {
                  <button type="button" nbButton status="primary" class="sort-indicator"
                          [class.sort-indicator--active]="sortPrimary(s)"
                          [attr.aria-label]="('sortby' | translate) + ' ' + (s.title | translate)">
                    @if (sorted(s); as sort) {
                      <nb-icon [icon]="sort === 1 ? 'arrow-up-outline' : 'arrow-down-outline'"></nb-icon>
                    } @else {
                      <span class="sort-indicator__idle" aria-hidden="true">
                        <nb-icon icon="arrow-up-outline"></nb-icon>
                        <nb-icon icon="arrow-down-outline"></nb-icon>
                      </span>
                    }
                  </button>
                }
                @if (s.filter !== false) {
                  <button nbButton status="primary" [class.active]="filtervalid(s)" (click)="filter(s, $event)"><nb-icon icon="funnel-outline"></nb-icon></button>
                }
              </div>
            </th>
          }
          @for (c of columns; track c) {
            <th (click)="sort(c, $event)" [title]="c.title | translate" [attr.aria-sort]="sortAria(c)" [style.text-align]="c.style?.['text-align']">
              @if (c.subtitle) {
                <span [nbTooltip]="c.subtitle | translate">{{ c.title | translate }}</span>
              }
              @if (!c.subtitle) {
                <span>{{ c.title | translate }}</span>
              }
              <div>
                @if (sortable(c)) {
                  <button type="button" nbButton status="primary" class="sort-indicator"
                          [class.sort-indicator--active]="sortPrimary(c)"
                          [attr.aria-label]="('sortby' | translate) + ' ' + (c.title | translate)">
                    @if (sorted(c); as sort) {
                      <nb-icon [icon]="sort === 1 ? 'arrow-up-outline' : 'arrow-down-outline'"></nb-icon>
                    } @else {
                      <span class="sort-indicator__idle" aria-hidden="true">
                        <nb-icon icon="arrow-up-outline"></nb-icon>
                        <nb-icon icon="arrow-down-outline"></nb-icon>
                      </span>
                    }
                  </button>
                }
                @if (c.filter !== false) {
                  <button nbButton status="primary" [class.active]="filtervalid(c)" (click)="filter(c, $event)"><nb-icon icon="funnel-outline"></nb-icon></button>
                }
              </div>
            </th>
          }
          @if (delegate.editable && delegate.editable.sort) {
            <th class="button-cell">
              {{ 'sort' | translate }}
            </th>
          }
          @if (hasRowMenu) {
            <th class="button-cell"></th>
          }
          @for (s of delegate.stickyColumnsRight; track s) {
            <th (click)="sort(s, $event)" class="sticky-column sticky-right" [attr.aria-sort]="sortAria(s)" [style.width.px]="s.stickyWidth" [style.min-width.px]="s.stickyWidth" [style.max-width.px]="s.stickyWidth">
              <span>{{ s.title | translate }}</span>
              <div>
                @if (sortable(s)) {
                  <button type="button" nbButton status="primary" class="sort-indicator"
                          [class.sort-indicator--active]="sortPrimary(s)"
                          [attr.aria-label]="('sortby' | translate) + ' ' + (s.title | translate)">
                    @if (sorted(s); as sort) {
                      <nb-icon [icon]="sort === 1 ? 'arrow-up-outline' : 'arrow-down-outline'"></nb-icon>
                    } @else {
                      <span class="sort-indicator__idle" aria-hidden="true">
                        <nb-icon icon="arrow-up-outline"></nb-icon>
                        <nb-icon icon="arrow-down-outline"></nb-icon>
                      </span>
                    }
                  </button>
                }
                @if (s.filter !== false) {
                  <button nbButton status="primary" [class.active]="filtervalid(s)" (click)="filter(s, $event)"><nb-icon icon="funnel-outline"></nb-icon></button>
                }
              </div>
            </th>
          }
        </tr>
        @if (delegate.header) {
          @for (h of delegate.header; track h) {
            <tr>
              @for (c of delegate.stickyColumnsLeft; track c) {
                <th class="sticky-column left">
                  <ng-container [ngTemplateOutlet]="delegate.headerCellTemplateOutlet" [ngTemplateOutletContext]="{row: h.data, column: c, node: h, isHeader: true}"></ng-container>
                </th>
              }
              @for (c of columns; track c) {
                <th [ngStyle]="c.style">
                  <ng-container [ngTemplateOutlet]="delegate.headerCellTemplateOutlet" [ngTemplateOutletContext]="{row: h.data, column: c, node: h, isHeader: true}"></ng-container>
                </th>
              }
              @for (c of delegate.stickyColumnsRight; track c) {
                <th>
                  <ng-container [ngTemplateOutlet]="delegate.headerCellTemplateOutlet" [ngTemplateOutletContext]="{row: h.data, column: c, node: h, isHeader: true}"></ng-container>
                </th>
              }
              @if (extralength) {
                <th [colSpan]="extralength"></th>
              }
            </tr>
          }
        }
      </thead>
      @for (o of delegate.data | sorted:(delegate.sorter ? delegate.sorter : null); track rowTrack(o)) {
        <tbody>
          <tr cdkDrag [cdkDragDisabled]="!(delegate.editable && delegate.editable.sort) || delegate.openCellTemplateOutlet != null" [cdkDragLockAxis]="'y'" (cdkDragStarted)="this.dragging = o" [ngClass]="delegate.rowClass ? delegate.rowClass(o.data) : null">
            <ng-container *cdkDragPreview></ng-container>
            @for (s of delegate.stickyColumnsLeft; track s) {
              <td [ngStyle]="s.style" class="sticky-column left">
                <ng-container [ngTemplateOutlet]="delegate.cellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, column: s, node: o, isHeader: false}">
                </ng-container>
              </td>
            }
            @for (c of columns; track c) {
              <td [ngStyle]="c.style" (click)="delegate.selectRow ? delegate.selectRow($event, o) : null">
                <ng-container [ngTemplateOutlet]="delegate.cellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, column: c, node: o, isHeader: false}">
                </ng-container>
              </td>
            }
            @if (delegate.editable && delegate.editable.sort) {
              <td class="button-cell draggable" cdkDragHandle>
                <nb-icon icon="menu"></nb-icon>
              </td>
            }
            @if (hasRowMenu) {
              <td class="button-cell">
                @if (rowMenu(o); as items) {
                  @if (items.length) {
                    <button nbButton ghost status="basic" size="tiny" class="row-kebab"
                            [nbPopover]="rowMenuTpl" nbPopoverTrigger="click" nbPopoverPlacement="left"
                            #rowKebabPop="nbPopover"
                            aria-label="Actions">
                      <nb-icon icon="more-vertical-outline"></nb-icon>
                    </button>
                    <ng-template #rowMenuTpl>
                      <div class="kebab-popup">
                        @for (it of items; track it.data.action) {
                          <button class="kebab-item" [class.kebab-item--danger]="it.data.action === 'delete'"
                                  (click)="rowMenuAction(it.data.action, it.data.node)">
                            <nb-icon [icon]="it.icon"></nb-icon>
                            {{ it.title }}
                          </button>
                        }
                      </div>
                    </ng-template>
                  }
                }
              </td>
            }
            @for (s of delegate.stickyColumnsRight; track s) {
              <td [ngStyle]="s.style" class="sticky-column sticky-right" [style.width.px]="s.stickyWidth" [style.min-width.px]="s.stickyWidth" [style.max-width.px]="s.stickyWidth">
                <ng-container [ngTemplateOutlet]="delegate.cellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, column: s, node: o, isHeader: false}">
                </ng-container>
              </td>
            }
          </tr>
          @if (delegate.openCellTemplateOutlet && o.expanded) {
            <tr class="expandable">
              <td [colSpan]="collength">
                <ng-container [ngTemplateOutlet]="delegate.openCellTemplateOutlet" [ngTemplateOutletContext]="{row: o.data, columns: columns, node: o, isHeader: false}">
                </ng-container>
              </td>
            </tr>
          }
        </tbody>
      }
      <tfoot>
        @if (loading.getValue() && (!delegate.data || !delegate.data.length)) {
          <tr class="sk-sr">
            <td class="filled-column" [attr.colspan]="collength" role="status" aria-live="polite">{{ 'loading' | translate }}</td>
          </tr>
          @for (r of skeletonRows; track r) {
            <tr class="sk-row" aria-hidden="true">
              @for (c of skeletonCols; track c) {
                <td><span class="sk-bar"></span></td>
              }
            </tr>
          }
        }
        @if (!loading.getValue() && !appending.getValue() && (loadFailed | async)) {
          <tr>
            <td class="filled-column noresults" role="alert">
              {{ 'loadfailed' | translate }}
              <button type="button" nbButton size="tiny" ghost status="primary" (click)="retry()">{{ 'retry' | translate }}</button>
            </td>
          </tr>
        } @else if (!loading.getValue() && !appending.getValue() && (!delegate.data || !delegate.data.length)) {
          <tr>
            <td class="filled-column noresults">
              {{ 'noresults' | translate }}
            </td>
          </tr>
        }
      </tfoot>
    </table>
    }
  </div>

  @if (pageResult && pagingMode === Globals.PagesMode){
    <bst-pager [paged]="pageResult" [disabled]="loading | async"
               [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
               (pageChange)="goToPage($event)"
               (pageSizeChange)="changePageSize($event)"></bst-pager>
  }
}
